// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* ::-webkit-scrollbar {
    background-color: hsl(235, 24%, 19%);
    width: 1px;
} */

.bars {
    font-size: 25px;
    color: white;
}

.top-section .logo img {
    width: 50px;
    border-radius: 100%;
}

.top-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
}

.sidebar-menu {
    margin-top: 0px;
    padding: 15px;
    /* height: 100%; */
    max-height: 100vh;
    width: 100%;
    padding-top: 10px;
    background: #2A2D3E;
    z-index: 100;
    box-shadow: 0px 10px 5px 0px rgba(249, 252, 253, 0.2);
    transition: 1s width ease;
    position: fixed;
    z-index: 1000;
    overflow-y: scroll;
}
.sidebar-menu::-webkit-scrollbar{
    display: none;
}




.container-2 {
    height: 100%;
    transition: 1s width ease-in-out;
    position: fixed;
    z-index: 1000;
}


.bottom-section {
    width: 100%;
}

.main-menu {
    height: 100vh;
}


.divider {
    width: 100%;
    height: 1px;
    background-color: rgba(206, 196, 196, 0.223);
    margin-top: 20px;
    margin-bottom: 20px;
}


.main-menu li {
    list-style: none;
}

.main-menu .menu-item {
    color: white;
    text-decoration: none;
    font-size: 15px;
    display: block;
    font-weight: 500;
    border-radius: 5px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    align-items: center;
    cursor: pointer;
}



.main-menu .menu-item .menu-icon {
    display: inline-block;
    width: 40px;
    height: 40px;
    font-size: 20px;
    padding-right: 10px;
    text-align: center;
}

.main-menu .menu-item .menu-icon2 {
    display: flex;
    width: 40px;
    height: 40px;
    font-size: 20px;
    text-align: center;
}

/* .main-menu .menu-item-1 {
    font-size: 15px;
    color: white;
    margin-bottom: 5px;
} */

.menu-item-1-active {
    font-size: 15px;
    color: #3D98E6;
    background-color: #666666;
    margin-bottom: 5px;
    display: block;
    /* margin: 5px 0; */
    height: 40px;
    padding-top: 7px;
    padding-left: 15px;
    border-radius: 5px;
    cursor: pointer;

}




.main-menu .sub-menu {
    /* border-left: 1px solid white; */
    /* margin-left: 25px; */
    box-sizing: border-box;
    /* padding-left: 30px; */
    margin-bottom: 20px;
    transition: border 1s ease-in-out;
    animation-name: border;
    animation-duration: 1s;
    margin-top: 10px;
}




.main-menu .sub-menu .menu-item-1 {
    display: block;
    /* margin: 5px 0; */
    height: 40px;
    padding-top: 7px;
    padding-left: 15px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 15px;
    color: white;
    margin-bottom: 5px;
}

.main-menu .sub-menu .menu-item-1:hover {
    background-color: #666666;
    color: #3D98E6;
}



.main-menu .menu-item:hover {
    background-color: #666666;
    color: #3D98E6 !important;
}



.flex {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}

.adjust {
    margin-top: 8px;
}

.left {
    margin-left: 10px;
    vertical-align: middle;
}



/* ---------------------------- animation ---------------- */

.animation {
    opacity: 1;
    animation-duration: 1s;
    animation-timing-function: linear;

}

.animation[ani='1'] {
    animation-name: back;
    animation-fill-mode: forwards;

    opacity: 1;
}

.animation[ani='0'] {
    animation-name: forward;
    animation-fill-mode: forwards;
    opacity: 0;
}

@keyframes back {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

@keyframes forward {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.animation-1 {
    opacity: 1;
    animation-duration: 1s;
    animation-timing-function: ease-in-out;

}

.animation-1[ani-1='1'] {
    animation-name: back;
    animation-fill-mode: forwards;

    opacity: 1;
}

.animation-1[ani-1='0'] {
    animation-name: forward;
    animation-fill-mode: forwards;
    opacity: 0;
}

@keyframes back {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

@keyframes forward {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.animation-2 {
    padding-left: 30px;
    margin-left: 25px;
    opacity: 1;
    animation-duration: 0.1s;
    animation-timing-function: ease-out;

}

.animation-2[ani-2='0'] {
    animation-name: paddingLeft-1;
    animation-fill-mode: forwards;

    padding-left: 0px;
    margin-left: 0px;
    opacity: 0;
}

.animation-2[ani-2='1'] {
    animation-name: paddingLeft-0;
    animation-fill-mode: forwards;
    padding-left: 30px;
    margin-left: 25px;
    opacity: 1;
}

@keyframes paddingLeft-1 {
    0% {
        padding-left: 0px;
        margin-left: 0px;
        opacity: 0;
    }

    100% {
        padding-left: 30px;
        margin-left: 25px;
        opacity: 1;
    }
}

@keyframes paddingLeft-0 {
    0% {
        padding-left: 30px;
        margin-left: 25px;
        opacity: 1;
    }

    100% {
        padding-left: 0px;
        margin-left: 0px;
        opacity: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/sidebar.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;;;GAGG;;AAEH;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,qDAAqD;IACrD,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;;;;;AAKA;IACI,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,aAAa;AACjB;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,WAAW;IACX,WAAW;IACX,4CAA4C;IAC5C,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;;;AAIA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;;;;GAIG;;AAEH;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;;AAEnB;;;;;AAKA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,sBAAsB;IACtB,wBAAwB;IACxB,mBAAmB;IACnB,iCAAiC;IACjC,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;AACpB;;;;;AAKA;IACI,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;;;AAIA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;;;;AAIA,4DAA4D;;AAE5D;IACI,UAAU;IACV,sBAAsB;IACtB,iCAAiC;;AAErC;;AAEA;IACI,oBAAoB;IACpB,6BAA6B;;IAE7B,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,sCAAsC;;AAE1C;;AAEA;IACI,oBAAoB;IACpB,6BAA6B;;IAE7B,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,wBAAwB;IACxB,mCAAmC;;AAEvC;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;;IAE7B,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI;QACI,iBAAiB;QACjB,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,iBAAiB;QACjB,UAAU;IACd;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,UAAU;IACd;AACJ","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n/* ::-webkit-scrollbar {\n    background-color: hsl(235, 24%, 19%);\n    width: 1px;\n} */\n\n.bars {\n    font-size: 25px;\n    color: white;\n}\n\n.top-section .logo img {\n    width: 50px;\n    border-radius: 100%;\n}\n\n.top-section {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 20px;\n}\n\n.sidebar-menu {\n    margin-top: 0px;\n    padding: 15px;\n    /* height: 100%; */\n    max-height: 100vh;\n    width: 100%;\n    padding-top: 10px;\n    background: #2A2D3E;\n    z-index: 100;\n    box-shadow: 0px 10px 5px 0px rgba(249, 252, 253, 0.2);\n    transition: 1s width ease;\n    position: fixed;\n    z-index: 1000;\n    overflow-y: scroll;\n}\n.sidebar-menu::-webkit-scrollbar{\n    display: none;\n}\n\n\n\n\n.container-2 {\n    height: 100%;\n    transition: 1s width ease-in-out;\n    position: fixed;\n    z-index: 1000;\n}\n\n\n.bottom-section {\n    width: 100%;\n}\n\n.main-menu {\n    height: 100vh;\n}\n\n\n.divider {\n    width: 100%;\n    height: 1px;\n    background-color: rgba(206, 196, 196, 0.223);\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n\n.main-menu li {\n    list-style: none;\n}\n\n.main-menu .menu-item {\n    color: white;\n    text-decoration: none;\n    font-size: 15px;\n    display: block;\n    font-weight: 500;\n    border-radius: 5px;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    padding: 0 10px;\n    align-items: center;\n    cursor: pointer;\n}\n\n\n\n.main-menu .menu-item .menu-icon {\n    display: inline-block;\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n    padding-right: 10px;\n    text-align: center;\n}\n\n.main-menu .menu-item .menu-icon2 {\n    display: flex;\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n    text-align: center;\n}\n\n/* .main-menu .menu-item-1 {\n    font-size: 15px;\n    color: white;\n    margin-bottom: 5px;\n} */\n\n.menu-item-1-active {\n    font-size: 15px;\n    color: #3D98E6;\n    background-color: #666666;\n    margin-bottom: 5px;\n    display: block;\n    /* margin: 5px 0; */\n    height: 40px;\n    padding-top: 7px;\n    padding-left: 15px;\n    border-radius: 5px;\n    cursor: pointer;\n\n}\n\n\n\n\n.main-menu .sub-menu {\n    /* border-left: 1px solid white; */\n    /* margin-left: 25px; */\n    box-sizing: border-box;\n    /* padding-left: 30px; */\n    margin-bottom: 20px;\n    transition: border 1s ease-in-out;\n    animation-name: border;\n    animation-duration: 1s;\n    margin-top: 10px;\n}\n\n\n\n\n.main-menu .sub-menu .menu-item-1 {\n    display: block;\n    /* margin: 5px 0; */\n    height: 40px;\n    padding-top: 7px;\n    padding-left: 15px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 15px;\n    color: white;\n    margin-bottom: 5px;\n}\n\n.main-menu .sub-menu .menu-item-1:hover {\n    background-color: #666666;\n    color: #3D98E6;\n}\n\n\n\n.main-menu .menu-item:hover {\n    background-color: #666666;\n    color: #3D98E6 !important;\n}\n\n\n\n.flex {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n}\n\n.adjust {\n    margin-top: 8px;\n}\n\n.left {\n    margin-left: 10px;\n    vertical-align: middle;\n}\n\n\n\n/* ---------------------------- animation ---------------- */\n\n.animation {\n    opacity: 1;\n    animation-duration: 1s;\n    animation-timing-function: linear;\n\n}\n\n.animation[ani='1'] {\n    animation-name: back;\n    animation-fill-mode: forwards;\n\n    opacity: 1;\n}\n\n.animation[ani='0'] {\n    animation-name: forward;\n    animation-fill-mode: forwards;\n    opacity: 0;\n}\n\n@keyframes back {\n    0% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n}\n\n@keyframes forward {\n    0% {\n        opacity: 0;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}\n\n.animation-1 {\n    opacity: 1;\n    animation-duration: 1s;\n    animation-timing-function: ease-in-out;\n\n}\n\n.animation-1[ani-1='1'] {\n    animation-name: back;\n    animation-fill-mode: forwards;\n\n    opacity: 1;\n}\n\n.animation-1[ani-1='0'] {\n    animation-name: forward;\n    animation-fill-mode: forwards;\n    opacity: 0;\n}\n\n@keyframes back {\n    0% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n}\n\n@keyframes forward {\n    0% {\n        opacity: 0;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}\n\n.animation-2 {\n    padding-left: 30px;\n    margin-left: 25px;\n    opacity: 1;\n    animation-duration: 0.1s;\n    animation-timing-function: ease-out;\n\n}\n\n.animation-2[ani-2='0'] {\n    animation-name: paddingLeft-1;\n    animation-fill-mode: forwards;\n\n    padding-left: 0px;\n    margin-left: 0px;\n    opacity: 0;\n}\n\n.animation-2[ani-2='1'] {\n    animation-name: paddingLeft-0;\n    animation-fill-mode: forwards;\n    padding-left: 30px;\n    margin-left: 25px;\n    opacity: 1;\n}\n\n@keyframes paddingLeft-1 {\n    0% {\n        padding-left: 0px;\n        margin-left: 0px;\n        opacity: 0;\n    }\n\n    100% {\n        padding-left: 30px;\n        margin-left: 25px;\n        opacity: 1;\n    }\n}\n\n@keyframes paddingLeft-0 {\n    0% {\n        padding-left: 30px;\n        margin-left: 25px;\n        opacity: 1;\n    }\n\n    100% {\n        padding-left: 0px;\n        margin-left: 0px;\n        opacity: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
